import { Flex, Spinner } from '@chakra-ui/react';
import React from 'react';

const NotFound = () => {
  const SpinnerCentered = () => (
    <Flex
      pos='fixed'
      zIndex='999'
      top='0'
      right='0'
      bottom='0'
      left='0'
      align='center'
      justify='center'
      w='100vw'
      h='100vh'
    >
      <Spinner size='xl' speed='0.65s' thickness='4px' />
    </Flex>
  );
  return <SpinnerCentered />;
};

export default NotFound;
